<template>
  <div id="app">
    <trioteca-widget/>
  </div>
</template>

<script>
/* eslint-disable */
import triotecaWidget from './components/TriotecaWidget.vue'
import VueSlider from 'vue-slider-component'
import vSelect from 'vue-select'
import Vue from 'vue'
import VeeValidate from 'vee-validate';
import { Validator } from 'vee-validate';

Vue.use(VeeValidate);
Vue.component('v-select', vSelect)
Vue.component('vue-slider', VueSlider)

const dict = {
    custom: {
        policy: {
            required: '* Tienes que aceptar los términos y condiciones para continuar',
        },
        province_id: {
            required: '* Tienes que seleccionar una provincia para continuar',
        },
        email: {
            required: '* Por favor rellena el campo con un email válido',
            email: '* Por favor rellena el campo con un email válido',
        },
    }
};
Validator.localize('es', dict);


export default {
  name: 'app',
  components: {
    triotecaWidget
  }
}
</script>

<style lang="scss">
@import "~vue-slider-component/dist-css/vue-slider-component.css";
@import '~vue-select/dist/vue-select.css';
</style>